export class AudioData {
  url?: string;
}


